"use client";

import { useI18n } from "@/i18n/client";
import { isValidJSON } from "@/utils/is-valid-json";
import { useProductContext } from "@/providers/ProductContextProvider";
import * as Accordion from "@radix-ui/react-accordion";
import IconArrow from "../../UI/Icon/IconArrow/IconArrow";
import Document from "./Document";
import accordionStyles from "../ProductPageAccordian.module.scss";
import styles from "./Documentation.module.scss";

const Documentation: React.FC = () => {
	const t = useI18n();
	const { product } = useProductContext();
	const warranty = isValidJSON(product.warranty);
	const documents = warranty.documentation_files;

	if (typeof documents === "undefined") return null;

	return (
		<Accordion.Item value='Documentation'>
			<Accordion.Header>
				<Accordion.Trigger className={accordionStyles.header}>
					<div className={accordionStyles.widthContainer}>
						{t("product.documentation")}
						<IconArrow
							direction='down'
							aria-labelledby='directional chevron pointing down'
						/>
					</div>
				</Accordion.Trigger>
			</Accordion.Header>
			<Accordion.Content className={accordionStyles.content}>
				<div className={accordionStyles.widthContainer}>
					<div className={styles.documentationWrapper}>
						{documents?.map(
							(
								document: { file_name: string; file_url: string },
								index: number,
							) => (
								<Document
									key={`${index}-${document.file_url}`}
									file_url={document.file_url}
									file_name={document.file_name}
								/>
							),
						)}
					</div>
				</div>
			</Accordion.Content>
		</Accordion.Item>
	);
};

export default Documentation;
